import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { CommonService } from 'src/app/services/common.service';
import { ColIdEnum } from 'src/app/services/reports.service';
import { TooltipContent, TooltipService } from 'src/app/services/tooltip.service';

@Component({
  selector: 'cell-static-tooltips',
  template: `<div class="cell-values">
    <span [ngClass]="cellClass" (mouseenter)="displayTooltip($event.target)" (mouseleave)="hideTooltip()">
      <ng-container [ngSwitch]="value">
        <span *ngSwitchCase="staticValues.unableToCalculate">{{ 'REPORTDATA.unableToCalculate' | translate }} </span>
        <span *ngSwitchCase="staticValues.notReported">{{ 'REPORTDATA.notReported' | translate }} </span>
        <span *ngSwitchDefault>{{ value }} </span>
        <span *ngIf="tooltipID">*</span>
      </ng-container>
    </span>
  </div>`,
  styles: [
    `
      .red {
        color: #ff0000;
        font-weight: bold;
      }
      .amber {
        color: #ff9900;
        font-weight: bold;
      }
      .green {
        color: #32a852;
        font-weight: bold;
      }
      .black {
        color: #000000;
        font-weight: bold;
      }
    `,
  ],
})
export class CellStaticTooltipsComponent implements ICellRendererAngularComp {
  staticValues: any = {
    unableToCalculate: 'Unable to Calculate',
    notReported: 'Not Reported',
  };

  colId: string;

  value: string;

  tooltipID?: string;

  cellClass?: string;

  /**
   * Creates a new instance of CellTooltipsComponent
   */
  constructor(private tooltipService: TooltipService) {}

  /**
   * Executes when the grid initialises
   */
  agInit(params: ICellRendererParams) {
    if (!params.value) {
      return;
    }

    this.colId = params.colDef.colId;
    this.value = params.data[this.colId];
    this.tooltipID = params.data[params['tooltipIDField']];
    this.cellClass = params.data[params['cellClassField']];
  }

  /**
   * Displays the category tooltip with the correct content.
   */
  public displayTooltip(targetElement: any): void {
    const content = this.tooltipService.getTooltipByID(this.tooltipID);

    if (content) {
      this.tooltipService.setContent(content);
      this.tooltipService.displayRelativeTo(targetElement);
    }
  }

  /**
   * Hides the category tooltip.
   */
  public hideTooltip(): void {
    this.tooltipService.hide();
  }

  /**
   * Executed when the component is refreshed.
   */
  public refresh(): boolean {
    return false;
  }
}
